import registerChangeLanguageDirective from './ChangeLanguageDirective';
import ChangeLanguageDirectiveController from './ChangeLanguageDirectiveController';

export default function registerChangeLanguage(angular) {
    registerChangeLanguageDirective(angular.module('assessmentFrontendDirectives'));
    angular.module('assessmentFrontendControllers').controller('ChangeLanguageDirectiveController', ['$scope', '$bridges', '$timeout', 'TaskInfoService', '$translate', '$signals', '$location', '$config', '$route', 'amMoment', ChangeLanguageDirectiveController]);
}